// ========================================
// 📁 dashboard/src/store/Reducers/ticketReducer.js
// ========================================

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'
import axios from 'axios';
import { api_url } from '../../utils/utils'
import { paginationTotal } from '../../utils/pagination'

export const get_all_tickets = createAsyncThunk(
    'ticket/get_all_tickets',
    async ({ page, parPage, status, searchValue }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken')

        // const config = {
        //     headers: {
        //         Authorization: `Bearer ${token}`
        //     },
        //     params: { page, parPage, status }
        // }

        try {
            const { data } = await axios.get(`${api_url}/api/admin/tickets`, { params: { page, parPage, status, searchValue }, withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Unauthorized' })
        }
    }
)
// ✅ 2. GET ALL VENDOR APPLICATIONS
export const get_all_vendor_applications = createAsyncThunk(
    'ticket/get_all_vendor_applications',
    async ({ page, parPage, status }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken')
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
    const query = new URLSearchParams({ page, limit: parPage, ...(status ? { status } : {}) }).toString()

const { data } = await axios.get(`${api_url}/api/admin/vendor-applications?${query}`, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// ✅ 3. APPROVE VENDOR APPLICATION
export const approve_vendor_application = createAsyncThunk(
    'ticket/approve_vendor_application',
    async ({ applicationId, adminNote }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await api.post(`/admin/vendor-applications/${applicationId}/approve`, {
                adminNote
            }, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// ✅ 4. REJECT VENDOR APPLICATION
export const reject_vendor_application = createAsyncThunk(
    'ticket/reject_vendor_application',
    async ({ applicationId, adminNote }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await api.post(`/admin/vendor-applications/${applicationId}/reject`, {
                adminNote
            }, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

const ticketReducer = createSlice({
    name: 'ticket',
    initialState: {
        loader: false,
        successMessage: '',
        errorMessage: '',
        tickets: [],
        totalTickets: 0,
        applications: [],
        totalApplications: 0
    },
    reducers: {
        messageClear: (state) => {
            state.successMessage = ''
            state.errorMessage = ''
        }
    },
    extraReducers: (builder) => {
        builder
            // ✅ GET TICKETS
            .addCase(get_all_tickets.fulfilled, (state, { payload }) => {
                state.tickets = payload.tickets || payload.data || []
                state.totalTickets = paginationTotal(payload, 'totalTickets')
            })
            
            // ✅ GET APPLICATIONS
            .addCase(get_all_vendor_applications.fulfilled, (state, { payload }) => {
                state.applications = payload.applications || payload.data || []
                state.totalApplications = paginationTotal(payload, 'totalApplications')
            })
            
            // ✅ APPROVE APPLICATION
            .addCase(approve_vendor_application.pending, (state) => {
                state.loader = true
            })
            .addCase(approve_vendor_application.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
            })
            .addCase(approve_vendor_application.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload.error
            })
            
            // ✅ REJECT APPLICATION
            .addCase(reject_vendor_application.pending, (state) => {
                state.loader = true
            })
            .addCase(reject_vendor_application.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
            })
            .addCase(reject_vendor_application.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload.error
            })
    }
})

export const { messageClear } = ticketReducer.actions
export default ticketReducer.reducer
